import React, { useState } from "react";
import BenifitsUI from "../Benifits/BenifitsUI";
import AccordBtn from "../../../../core-components/AccordBtn/AccordBtnUI";
import Radiobox from "../../../../core-components/Radio/RadioUI";
import * as S from "./SecureYourTrip.styles";
import Icon from "../../../../core-components/IconsSelector";
  
interface ISecureTrip {
  subtitle: string;
  benefits: Array<{}>;
  margin: string;
  title: string;
  benefits_url: string;
  is_selected: string;
  updateSelectedData: Function;
  insurance_opted: any
}

const SecureYourTripUI: React.FC<ISecureTrip> = ({
  title = '',
  subtitle = '',
  benefits = '',
  benefits_url = "",
  is_selected = "",
  margin = "",
  updateSelectedData = () => { },
  insurance_opted = ''
}) => {
  const [toggle, setToggle] = useState(true);
  const handlePolicy = () => {
    setToggle(!toggle);
  };

  return (
    <S.SecureCont margin={margin}>
      <S.SecureHeader>
        <div>
          {title ? <h3>{title}</h3> : null}
          <div className="poweredBy">
            <Icon name="AckoIcon" styleProps={{ width:"4.4rem" }} />
            <span className="poweredByText">{'Powered by Acko'}</span>
          </div>
        </div>
        <AccordBtn active={toggle} onClick={handlePolicy} margin="0 0 0 2rem" />
      </S.SecureHeader>
      {toggle && (
        <S.SecureContent>
          <BenifitsUI benefits={benefits} margin="0 0 5rem 0" />
          <ul className="tncList">
            <li>
              <Radiobox>
                <input type="radio" name="sGroup" id="tnc" onChange={() => updateSelectedData({ insurance_opted: true })} checked={!!insurance_opted} />
                <label htmlFor="tnc">
                  Yes, secure my trip. I agree to the given
                </label>
                <a className="tncText" target="_blank" href={benefits_url}>Terms and Conditions</a>
              </Radiobox>
            </li>
            <li>
              <Radiobox>
                <input type="radio" name="sGroup" id="risk" onChange={() => updateSelectedData({insurance_opted: false})} checked={insurance_opted === false}/>
                <label htmlFor="risk">No, I am willing to risk my trip</label>
              </Radiobox>
            </li>
          </ul>
          <div className="makeFlex hrtlCenter">
            <span className="requiredTag">Required</span>
            <span className="requiredText">
              Please select one of the above option
            </span>
          </div>
        </S.SecureContent>
      )}
    </S.SecureCont>
  );
};

export default React.memo(SecureYourTripUI);
